//Enter only max of 5 tags

const MoreProjectsDetails = [
  {
    url: "https://res.cloudinary.com/dcgefz04y/image/upload/v1617297635/projects/flashsalebot_xxxkln.jpg",
    title: "Amazon flash sale bot",
    startdate: "07/2020",
    enddate: "07/2020",
    tags: ["Python", "Bot", "Selenium", "Automation", "Web Scraping"],
    desc: "Python script to automate buying products from Amazon during flash sales",
    code: "https://github.com/veerreshr/amazon_flash_sale_bot",
    live: "",
  },
  {
    url: "https://res.cloudinary.com/dcgefz04y/image/upload/v1617297635/projects/studentcompanion_fwakjc.png",
    title: "Student Companion",
    startdate: "04/2020",
    enddate: "05/2020",
    tags: ["HTML", "CSS", "JavaScript", "PHP", "SQL", "Web", "MySQL", "Bootstrap"],
    desc: "It's a attendance app which takes the persons daily attendance and shows it in visual representation and gives remainder for every class , with notes feature (with remainder feature) and also a remarks page which displays the performance of the person with some suggestions to improve.Few more features to edit and delete",
    code: "https://github.com/veerreshr/student-companion",
    live: "https://veerreshr.000webhostapp.com/index.php",
  },
  {
    url: "https://res.cloudinary.com/dcgefz04y/image/upload/v1617306461/projects/pubgproject_mwuwtu.png",
    title: "RedMealey",
    startdate: "11/2019",
    enddate: "01/2020",
    tags: ["HTML", "CSS", "JavaScript", "PHP", "SQL", "Web", "MySQL", "Bootstrap"],
    desc: "It's a Simple mock(not real) online gaming tournament platform made using php .",
    code: "https://github.com/veerreshr/pubg-project",
    live: "https://redmealey.000webhostapp.com",
  },
  {
    url: "https://res.cloudinary.com/dcgefz04y/image/upload/v1617297688/projects/WaterApp_wncrq5.jpg",
    title: "Water App",
    startdate: "05/2020",
    enddate: "06/2020",
    tags: ["Flutter", "Dart", "Android App", "Mobile", "Firebase"],
    desc: "Its a water app that reminds you to drink water frequently according to your body type. It does record your weekly/monthly water consumption, which helps you in analyzing your health. You can add a custom reminder as an alternative from default remainders.",
    code: "https://github.com/veerreshr/WaterApp",
    live: "drive.google.com/file/d/1v7ewu86ahrxebpe9mcxyn6sb9gb0z7eu/view",
  },
  {
    url: "https://res.cloudinary.com/dcgefz04y/image/upload/v1617298699/projects/rockpaperscissor_wcrgdk.png",
    title: "Rock Paper Scissor game",
    startdate: "07/2020",
    enddate: "07/2020",
    tags: ["HTML", "CSS", "JavaScript", "Game", "Web"],
    desc: "It's a rock, paper and scissor game inspired from codementor. Its a single person offline game played against the system, where a random winner is chosen according to the rules and result will add or subtract a point from overall game points.",
    code: "https://github.com/veerreshr/Rock-Paper-Scissors-game",
    live: "https://simple-rps.netlify.app/",
  },
  {
    url: "https://res.cloudinary.com/dcgefz04y/image/upload/v1617299022/projects/drummachine_vmetyr.png",
    title: "Drum-Machine",
    startdate: "07/2020",
    enddate: "07/2020",
    tags: ["React", "JavaScript", "Web", "CSS", "HTML"],
    desc: "It's a React mini project made using react hooks and it's context api for state management",
    code: "https://github.com/veerreshr/Drum-Machine",
    live: "https://veerreshr.github.io/Drum-Machine/",
  },
  {
    url: "https://res.cloudinary.com/dcgefz04y/image/upload/v1617299354/projects/randomquotemachine_pdx1kw.png",
    title: "Random-Quote-Machine",
    startdate: "07/2020",
    enddate: "07/2020",
    tags: ["React", "JavaScript", "Web", "CSS", "HTML", "API"],
    desc: "It's a React mini project done with freecodecamp curriculum. Which uses quotes api to randomly get a quote each time user requests and also allows users to share their quotes to their twitter and whatsapp.",
    code: "https://github.com/veerreshr/Drum-Machine",
    live: "https://veerreshr.github.io/Random-quote-machine/",
  },
  {
    url: "https://res.cloudinary.com/dcgefz04y/image/upload/v1617299700/projects/markdownpreviewer_obudsb.png",
    title: "Markdown previwer",
    startdate: "07/2020",
    enddate: "07/2020",
    tags: ["React", "JavaScript", "Web", "CSS", "HTML", "Markdown"],
    desc: "This application allows you to write your markdown content in the editor and view its output simultaneously in the preview window. This was made possible by using packages such as react-markdown, and handled the state using the React Context API.",
    code: "https://github.com/veerreshr/Markdown-Previewer",
    live: "https://markdown-viewer.netlify.app/",
  },
  {
    url: "https://res.cloudinary.com/dcgefz04y/image/upload/v1617299847/projects/reactcalculator_l58l2p.png",
    title: "React Calculator",
    startdate: "07/2020",
    enddate: "08/2020",
    tags: ["React", "JavaScript", "Web", "CSS", "HTML"],
    desc: "It's a simple calculator made using react in freecodecamp curriculum.",
    code: "https://github.com/veerreshr/react-calculator",
    live: "https://veerreshr.github.io/react-calculator/",
  },
  {
    url: "https://res.cloudinary.com/dcgefz04y/image/upload/v1617300944/projects/qutebot_bdkdlt.png",
    title: "QuteBot",
    startdate: "09/2020",
    enddate: "09/2020",
    tags: ["Github Actions", "JavaScript", "Telegram", "Bot", "Automation", "API"],
    desc: "This is a Telegram bot that uses GitHub actions to send inspiring quotes every day at 8 am IST.",
    code: "https://github.com/veerreshr/quteBot",
    live: "",
  },
  {
    url: "https://res.cloudinary.com/dcgefz04y/image/upload/v1617303094/projects/ipaddresstracker_kbstfe.png",
    title: "IP Address Tracker",
    startdate: "09/2020",
    enddate: "09/2020",
    tags: ["HTML", "CSS", "JavaScript", "Web", "API", "Leaflet"],
    desc: "It's a simple IP address tracker app, which takes an IP address as an input and gives out relevant information about the device (like location, Timezone, ISP) with a visual representation of the location.",
    code: "",
    live: "https://ipaddresstrack.netlify.app/",
  },
  {
    url: "https://res.cloudinary.com/dcgefz04y/image/upload/v1617303595/projects/wildhubdesigns_gd7648.png",
    title: "Wildhub designs",
    startdate: "09/2020",
    enddate: "11/2020",
    tags: ["HTML", "CSS", "JavaScript", "gsap", "Web", "Bootstrap", "Animation"],
    desc: "Redesigned an architectural corporate website and made dynamic, faster and secure. Using the gsap javascript library to smoothen animations and recaptcha implementation to have an extra layer of security when submitting contact forms.",
    code: "",
    live: "https://wildhubdesigns.com",
  },
  {
    url: "https://res.cloudinary.com/dcgefz04y/image/upload/v1617304164/projects/materialworld_utg88m.png",
    title: "Material World",
    startdate: "11/2020",
    enddate: "01/2021",
    tags: ["JavaScript", "MongoDB", "Web", "Bootstrap", "React", "Node.js", "Express", "PayPal"],
    desc: "Its a simple e-commerce site with two login types, i.e., admin and normal user. Where an admin can manage all types of activities inside the app. This website uses PayPal checkout integration for a seamless transaction across countries.",
    code: "https://github.com/veerreshr/material-world",
    live: "https://material-world.herokuapp.com/",
  },
  {
    url: "https://res.cloudinary.com/dcgefz04y/image/upload/v1617304428/projects/moviesinfo_otkcns.png",
    title: "Movies Info",
    startdate: "02/2021",
    enddate: "03/2021",
    tags: ["JavaScript", "MongoDB", "Web", "Bootstrap", "React", "Node.js", "Express", "API"],
    desc: "Simple movies app with all basic CRUD operations.",
    code: "https://github.com/veerreshr/imdb-clone",
    live: "https://moviesinfoin.herokuapp.com",
  },
  {
    url: "https://res.cloudinary.com/dcgefz04y/image/upload/v1617305671/projects/get_screenshot_t8hwhx.png",
    title: "get-screenshot",
    startdate: "03/2021",
    enddate: "04/2021",
    tags: ["JavaScript", "Node.js", "puppeteer", "api", "Express"],
    desc: "Its a simple rest api to get screenshot of web url. Replace google.com by your url to get screenshot of webpage using this api https://get-screenshot.herokuapp.com/api/screenshot/google.com",
    code: "https://github.com/veerreshr/get-screenshot/blob/main/README.md",
    live: "",
  },
  {
    url: "https://res.cloudinary.com/dcgefz04y/image/upload/v1617526494/projects/portfolio2_rqkiwj.jpg",
    title: "Portfolio 2",
    startdate: "09/2020",
    enddate: "11/2020",
    tags: ["JavaScript", "HTML", "CSS", "Web", "Portfolio", "Bootstrap"],
    desc: "A simple personal website",
    code: "https://github.com/veerreshr/portfolio",
    live: "https://veerreshr.github.io/portfolio/",
  },
  {
    url: "https://res.cloudinary.com/dcgefz04y/image/upload/v1617530890/projects/portfolio1_tz4ems.png",
    title: "Portfolio 1",
    startdate: "06/2020",
    enddate: "07/2020",
    tags: ["JavaScript", "HTML", "CSS", "Web", "Portfolio", "Bootstrap"],
    desc: "A simple personal website with clean interface",
    code: "https://github.com/veerreshr/veerreshr.github.io/tree/master/Portfolio",
    live: "https://veerreshr.github.io/Portfolio/",
  },
  {
    url: "https://res.cloudinary.com/dcgefz04y/image/upload/v1617531183/projects/simpleportfolio_wjoq8x.png",
    title: "Simple Portfolio",
    startdate: "01/2021",
    enddate: "04/2021",
    tags: ["JavaScript", "React", "Web", "Portfolio", "Material UI", "CSS", "HTML"],
    desc: "A simple personal website with material design",
    code: "https://github.com/veerreshr/simple-portfolio",
    live: "https://veereshr.netlify.app/",
  },
  {
    url: "https://res.cloudinary.com/dcgefz04y/image/upload/v1617557849/projects/Medical_Record_Automation_dnsdqe.png",
    title: "Medical Record Automation",
    startdate: "10/2020",
    enddate: "12/2020",
    tags: ["Automation Anywhere", "RPA", "Bot", "Automation", "Healthcare"],
    desc: "The Main objective of this project is to automate appointment and record making process in hospitals. Automating the appointment not only speeds up the process but also makes it less error prone and adopting the paper less environment. This automation also reduces the effort for storing and maintaining medical reports by both patients and hospitals. ",
    code: "https://drive.google.com/file/d/1apdNa8vNEStsuWVmuFUIg4_adE99AE1t/view?usp=sharing",
    live: "https://www.youtube.com/watch?v=nyboyQoJHP0&t=11s",
  },
  {
    url: "https://res.cloudinary.com/dcgefz04y/image/upload/v1617558092/projects/covidupdates_o1w4sm.jpg",
    title: "Covid updates",
    startdate: "10/2020",
    enddate: "10/2020",
    tags: ["Automation Anywhere", "RPA", "Bot", "Automation", "Healthcare", "Email"],
    desc: "Its an RPA bot which takes mail ids from CSV and sends daily covid updates(Daily changes of covid cases in India) to them. ",
    code: "",
    live: "https://www.youtube.com/watch?v=HO7Ap7rGDFM",
  },
  {
    url: "https://res.cloudinary.com/dcgefz04y/image/upload/v1617558339/projects/twitter_like_bot_t2zkiu.jpg",
    title: "Twitter Like Bot",
    startdate: "09/2020",
    enddate: "09/2020",
    tags: ["Automation Anywhere", "RPA", "Bot", "Automation", "Social Media"],
    desc: "Simple twitter like bot, which likes specified amount of tweets with specified hashtag ",
    code: "",
    live: "https://www.youtube.com/watch?v=qR3zKwAx-qg",
  },
  {
    url: "https://res.cloudinary.com/dcgefz04y/image/upload/v1624581786/we8tracker_j4c6r1.png",
    title: "We8-Tracker",
    startdate: "05/2021",
    enddate: "06/2021",
    tags: ["React", "Firebase", "JavaScript", "Web", "CSS", "HTML", "Material UI"],
    desc: "Keep track of your weight - Weight Tracker makes it simple. Create an account, add your weight each time you weigh yourself, and see how far you've come!",
    code: "https://github.com/veerreshr/simple-weight-tracker",
    live: "https://we8-tracker.netlify.app/",
  },
  {
    url: "https://res.cloudinary.com/dcgefz04y/image/upload/v1627933811/Team_Maker_Logo_dqnxak.png",
    title: "Team Maker",
    startdate: "06/2021",
    enddate: "05/2022",
    tags: [
      "React",
      "Node.js",
      "Express",
      "MongoDB",
      "Material UI",
      "Socket.io",
      "Web",
      "JavaScript",
      "CSS",
      "HTML",
      "Real-time"
    ],
    desc: "A platform to find and connect with  team members for your next Big Project .",
    code: "https://github.com/veerreshr/team-maker/",
    live: "https://connect-team.herokuapp.com/",
  },
  {
    url: "https://res.cloudinary.com/dcgefz04y/image/upload/v1627455237/RoadScan_fn4lj4.png",
    title: "RoadScan",
    startdate: "07/2021",
    enddate: "07/2021",
    tags: [
      "Vite.js",
      "Material UI",
      "Fusion Charts",
      "Sensors",
      "Firebase",
      "Web",
      "React",
      "JavaScript",
      "CSS",
      "HTML"
    ],
    desc: "It is a concept web application which primarily detects the potholes using smartphone sensors(accelerometer and more) and also helps people by notifying them about the occurrence of potholes ahead of time.",
    code: "https://github.com/veerreshr/Road-Monitoring-Frontend",
    live: "https://roadscan.netlify.app/",
  },
  {
    url: "https://devfolio-prod.s3.ap-south-1.amazonaws.com/hackathons/49e46b2eb8824728abedbe064dcd10bf/projects/1207606b37734063936bb1eb8552108d/29c6597f-98de-4384-9775-6234cab5d323.png",
    title: "PG Hunt",
    startdate: "03/2022",
    enddate: "03/2022",
    tags: [
      "React",
      "Node.js",
      "Express",
      "MongoDB",
      "Material UI",
      "Web",
      "JavaScript",
      "CSS",
      "HTML"
    ],
    desc: "An Online Paying Guest Finder with three kinds of user roles : Normal User, Host, Admin",
    code: "https://github.com/pg-hunt/PG_HUNT",
    live: "https://pg-hunt.herokuapp.com/",
  },
  {
    url: "https://user-images.githubusercontent.com/59141533/167292402-b6a331f8-2776-430b-9fd6-456f084df035.png",
    title: "Resume Chain",
    startdate: "05/2022",
    enddate: "08/2022",
    tags: [
      "React",
      "Zustand",
      "Material UI",
      "Solidity",
      "IPFS",
      "Moralis",
      "Blockchain",
      "Web",
      "JavaScript",
      "CSS",
      "HTML",
      "Web3"
    ],
    desc: "A Blockchain based resume builder equiped with document verifier.",
    code: "https://github.com/veerreshr/resume-chain",
    live: "https://resumechain.netlify.app/",
  },
  {
    url: "https://user-images.githubusercontent.com/59141533/177357456-1dbc4e5d-69f9-46d6-91f1-c99e40edcaa6.png",
    title: "Text To Face",
    startdate: "05/2022",
    enddate: "08/2022",
    tags: ["Python","Pytorch","Numpy","PIL(Python Imaging Library)","Colab","Flask","ngrok","HTML","CSS","Javascript","Typescript","Vite.js", "React","Material UI","Web","ML","DeepLearning","AI"],
    desc: "The Text-To-Face project is a research-driven implementation using GAN-based models, including a baseline GAN and VQGAN+CLIP, to generate facial images from text descriptions. It combines deep learning in Python with a web-based interface and a voice assistant for showcasing results.",
    code: "https://github.com/veerreshr/Text-To-Face-Frontend",
    live: "https://www.loom.com/share/7c8ea9c1857b425eb2eec5c3fde88fda",
  },
  {
    url: "https://github.com/user-attachments/assets/f93c46ed-9f7d-4656-b114-1c3df0d09088",
    title: "Focused Time",
    startdate: "04/2025",
    enddate: "04/2025",
    tags: ["HTML","CSS","Javascript","Typescript","Vite.js", "React","Tailwind","React Context"],
    desc: "A simple, offline-first web application designed to help you plan, track, and report progress towards your goals with granular hourly scheduling.",
    code: "https://github.com/veerreshr/focusedtime",
    live: "https://focusedtime.netlify.app/",
  },
  {
    url:"https://store-images.s-microsoft.com/image/apps.54008.c75e5486-b3b2-498f-bd64-8348a399fd0c.3f3151e4-9bb1-4cf3-9865-ce4d526765b3.279ce245-25ca-405d-8e34-f3f51c182d6d",
    title: "Site Notes",
    startdate: "09/2026",
    enddate: "09/2026",
    tags: ["HTML","CSS","Javascript","Typescript","Vite.js", "React","Tailwind","wxt","Chrome Extension"],
    desc: "A Chrome side-panel extension for taking notes on any website. Notes are stored locally in browser storage and can be scoped to the current URL or the entire domain.",
    code: "https://github.com/veerreshr/Notes-Browser-Extension",
    live: "https://microsoftedge.microsoft.com/addons/detail/site-notes/copilkogjfmfhbncggnmnfafjgakjhai",
  }
];
export default MoreProjectsDetails;
